<template>
  <!-- the router guards check the session before any page renders (router/index.js) -->
  <!-- keyed by path: the ETL report routes share one component, so a route change must remount it -->
  <router-view :key="$route.path" />
</template>
